module.exports = __webpack_public_path__ + "static/img/success-icon.1218fa2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/payment/success-icon.png
// module id = 4De+
// module chunks = 1